"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MbDRPicasoAuthenticator = void 0;
const framework_1 = require("../../../framework");
const types_1 = require("../../../features/session/cc/types");
const config_1 = require("../../../features/azureCommons/config");
const helper_1 = require("../cc/helper");
const timeOut_helper_1 = require("../../../features/timeOut/helpers/timeOut.helper");
const framework_2 = require("../../../framework");
class MyKeycloakSession extends framework_1.KeycloakSession {
    doRefresh() {
        throw new Error('Method not implemented.');
    }
}
class MyAzureSession extends framework_1.AzureSession {
    doRefresh() {
        throw new Error('Method not implemented.');
    }
}
//TODO Authenticator only for model or not??
class MbDRPicasoAuthenticator extends framework_2.BaseAuthenticator {
    constructor(session, xhr, helper, urlConfig, authStore) {
        super(session);
        this.agentToken = '';
        this.agentRefreshToken = '';
        this.doLogout = () => __awaiter(this, void 0, void 0, function* () {
            var _a;
            const accessToken = (_a = this.getSession().getData()) === null || _a === void 0 ? void 0 : _a.accessToken;
            yield this.xhr.POST(this.urlConfig.logout, { accessToken });
        });
        this.doLogin = (data) => __awaiter(this, void 0, void 0, function* () {
            const loginResult = yield this.helper.requestLogin(data);
            return Object.assign(Object.assign({}, loginResult), { agentToken: this.agentToken, agentRefreshToken: this.agentRefreshToken, username: data.username, timeOutStamp: (0, timeOut_helper_1.getTimeOutStamp)(loginResult.expiresIn), entrypoint: types_1.EntrypointType.DRPicaso });
        });
        this.loginAgent = () => __awaiter(this, void 0, void 0, function* () {
            const data = this.authSystem === 'AZURE' ? yield this.loginAzure() : yield this.loginKeycloak();
            return data;
        });
        this.loginAzure = () => __awaiter(this, void 0, void 0, function* () {
            var _a, _b, _c;
            yield ((_a = this.azure) === null || _a === void 0 ? void 0 : _a.login(config_1.loginRequest));
            const data = (_b = this.azureSession) === null || _b === void 0 ? void 0 : _b.getData();
            if (data) {
                this.agentToken = data.accessToken;
                this.agentRefreshToken = data.refreshToken;
                const sessionData = {
                    accessToken: '',
                    refreshToken: '',
                    agentRefreshToken: data.refreshToken,
                    agentToken: data.accessToken,
                    username: '',
                    expiresIn: (_c = data.expiresIn) !== null && _c !== void 0 ? _c : 5000,
                    timeOutStamp: (0, timeOut_helper_1.getTimeOutStamp)(data.expiresIn),
                    sessionExpiresAt: (0, helper_1.createSessionExpiresAt)(),
                    entrypoint: types_1.EntrypointType.DRPicaso,
                };
                this.session.initSession(sessionData);
                return sessionData;
            }
            return null;
        });
        this.loginKeycloak = () => __awaiter(this, void 0, void 0, function* () {
            var _a, _b, _c, _d;
            yield ((_a = this.keycloak) === null || _a === void 0 ? void 0 : _a.init({
                checkLoginIframe: false,
                onLoad: 'login-required',
            }));
            yield ((_b = this.keycloak) === null || _b === void 0 ? void 0 : _b.login({}));
            const data = (_c = this.keycloakSession) === null || _c === void 0 ? void 0 : _c.getData();
            if (data) {
                this.agentToken = data.accessToken;
                this.agentRefreshToken = data.refreshToken;
                const sessionData = {
                    accessToken: '',
                    refreshToken: '',
                    agentRefreshToken: data.refreshToken,
                    agentToken: data.agentToken,
                    username: '',
                    expiresIn: (_d = data.expiresIn) !== null && _d !== void 0 ? _d : 5000,
                    timeOutStamp: (0, timeOut_helper_1.getTimeOutStamp)(data.expiresIn),
                    sessionExpiresAt: (0, helper_1.createSessionExpiresAt)(),
                    entrypoint: types_1.EntrypointType.DRPicaso,
                };
                this.session.initSession(sessionData);
                return sessionData;
            }
            return null;
        });
        this.requestInteractionId = (param) => {
            return this.helper.requestInteractionId(param);
        };
        this.requestPasswordPosition = (param) => {
            return this.helper.requestPasswordPosition(param);
        };
        this.helper = helper;
        this.xhr = xhr;
        this.authSystem = window.AUTH_SYSTEM;
        this.urlConfig = urlConfig;
        if (this.authSystem === 'KEYCLOAK') {
            this.keycloakSession = new MyKeycloakSession(authStore);
            this.keycloak = new framework_1.KeycloakAuthenticator(this.keycloakSession, {
                url: window.KEYCLOAK_AUTH_URL, // keycloak server
                realm: 'master',
                clientId: window.KEYCLOAK_AUTH_CLIENTID,
            });
        }
        else if (this.authSystem === 'AZURE') {
            this.azureSession = new MyAzureSession(authStore);
            this.azure = new framework_1.AzureAd(this.azureSession, config_1.msalConfig);
        }
    }
}
exports.MbDRPicasoAuthenticator = MbDRPicasoAuthenticator;
//# sourceMappingURL=index.js.map